export type BiometricReason = 'session-lock' | 'high-value-txn';

export type BiometricCheckResult =
  | { ok: true; reason: BiometricReason; viaPlugin: boolean }
  | { ok: false; reason: BiometricReason; cause: BiometricFailureCause };

export type BiometricFailureCause =
  | 'cancelled'
  | 'unavailable'
  | 'locked-out'
  | 'flag-disabled'
  | 'below-threshold'
  | 'unknown';

export const DEFAULT_HIGH_VALUE_THRESHOLD_INR = 10_000;

/** Gap between successful auths inside which we suppress re-prompts (ms). */
export const BIOMETRIC_DEBOUNCE_MS = 30_000;

/**
 * How long the app may be backgrounded (or idle since the last successful auth,
 * at cold start) before the session-lock re-prompts. Kept short so the lock
 * actually re-arms on resume; long enough to absorb the OS biometric sheet
 * (which itself backgrounds the app for a few seconds) and quick app-switches.
 * Tune here.
 */
export const SESSION_LOCK_IDLE_MS = 60_000;
